<template>
  <form :class="mobileVersion ? style.mobile : ''" id="contactsForm">
    <textarea
      name="header"
      id="header"
      v-if="mobileVersion"
      placeholder="Введите заголовок"
      :value="
        modifyQuiz('get', '', [
          'questions',
          selectedQuestion,
          'contacts',
          'headerMobile',
          'placeholder'
        ])
      "
      @input="setHeaderForm"
    />

    <textarea
      name="description"
      id=""
      v-if="mobileVersion"
      placeholder="Введите описание"
      :value="
        modifyQuiz('get', '', [
          'questions',
          selectedQuestion,
          'contacts',
          'paragraphMobile',
          'placeholder'
        ])
      "
      @input="setParagraphForm"
    />

    <div
      :class="style.formGroup"
      v-if="currentQuestionData.contacts?.name?.bool"
    >
      <div :class="style.spanGroup" v-if="!mobileVersion">
        <span v-text="fieldIndexMap.name" />
        <span>Введите имя</span>
      </div>

      <input :class="style.input" placeholder="Введите ваше имя" />
    </div>

    <div
      :class="style.formGroup"
      v-if="currentQuestionData.contacts?.email?.bool"
    >
      <div :class="style.spanGroup" v-if="!mobileVersion">
        <span v-text="fieldIndexMap.email" />
        <span>Введите email</span>
      </div>

      <input :class="style.input" placeholder="Введите ваш email" />
    </div>

    <div
      :class="style.formGroup"
      :style="mobileVersion ? {flexDirection: 'column'} : {}"
      v-if="currentQuestionData.contacts?.connectionList?.bool"
    >
      <div :class="style.spanGroup">
        <span v-if="!mobileVersion" v-text="fieldIndexMap.connection" />
        <span>Выберите способ связи</span>
      </div>

      <div :class="style.formGroupSlide">
        <label
          v-for="connection in connections"
          :key="connection.id"
          :class="[
            style.socialBlock,
            currentConnectionId.includes(connection.id) ? style.active : ''
          ]"
          @click.prevent="changeConnection"
        >
          <input type="checkbox" :id="connection.id" />
          {{ connection.title }}
        </label>
      </div>
    </div>

    <div
      :class="style.formGroup"
      v-if="currentQuestionData.contacts?.phone?.bool"
    >
      <div :class="style.spanGroup" v-if="!mobileVersion">
        <span v-text="fieldIndexMap.phone" />
        <span>Введите телефон</span>
      </div>

      <PhoneInput
        :class="style.input"
        :style="{paddingLeft: '90px', backgroundColor: '#fbfbfb'}"
        v-if="!currentQuestionData.phoneMask"
      />

      <input :class="style.input" placeholder="857 543-23-12" v-else />

      <div
        :class="style.flagCountryBlock"
        v-if="!currentQuestionData.phoneMask"
      >
        <img
          src="$images/flags/russia.svg"
          v-if="currentQuestionData?.contacts?.country === 'Россия (+7)'"
        />

        <img
          src="$images/flags/kz.svg"
          v-else-if="
            currentQuestionData?.contacts?.country === 'Казахстан (+7)'
          "
        />

        +7
      </div>
    </div>

    <div :class="style.formGroup">
      <button
        :class="[styleLeftPart.nextButton, style.nextButton]"
        @click.prevent
        :style="{margin: '0 0 20px'}"
      >
        <input
          :value="textContactButton"
          @input="setTextContactButton"
          :size="getSizeInNextButton()"
          :class="styleLeftPart.textButton"
          placeholder="Введите текст"
          :style="{height: '20px!important'}"
        />
      </button>
    </div>
  </form>
</template>

<script lang="ts">
import {defineComponent} from "vue";

import style from "./FormEditComponent.module.scss";
import styleLeftPart from "@/page/quiz/editor/landingPage/components/sections/LeftPart/LeftPart.module.scss";

import {modifyQuiz} from "@/page/quiz/scriptQuiz";

import russiaSvg from "$images/flags/russia.svg";
import kzSvg from "$images/flags/kz.svg";

import PhoneInput from "@/elements/phoneInput/PhoneInput.vue";
import {connection, Contacts, CountryName} from "@/page/quiz/typeQuiz";

type Country = {
  code: string;
  name: CountryName;
  flag: string;
};

type ContactKey = "email" | "name" | "phone";

export default defineComponent({
  name: "FormEditComponent",

  components: {
    PhoneInput
  },

  data() {
    return {
      style,
      styleLeftPart,

      connections: [
        {
          id: "phone",
          title: "Телефон"
        },
        {
          id: "whatsapp",
          title: "Whats App"
        },
        {
          id: "viber",
          title: "Viber"
        },
        {
          id: "telegram",
          title: "Telegram"
        }
      ] as {id: string; title: string}[],

      countries: [
        {
          code: "ru",
          name: "Россия (+7)",
          flag: russiaSvg
        },
        {
          code: "kz",
          name: "Казахстан (+7)",
          flag: kzSvg
        }
      ] as Country[],

      selectedCountry: null as Country | null,
      isOpenDropdown: false,
      modifyQuiz
    };
  },

  mounted() {
    document.addEventListener("click", this.onClickOutside);

    const normalizedCountry = this.normalizeCountry(this.contacts?.country);

    this.selectedCountry = this.countries.filter((country: Country) => {
      return country.name === normalizedCountry;
    })[0] ?? {...this.countries[0]};

    if (this.currentQuestionData.contacts?.country) {
      this.currentQuestionData.contacts.country = normalizedCountry;
    } else {
      this.setDefaultRegionalNumber();
    }
  },

  beforeUnmount() {
    document.removeEventListener("click", this.onClickOutside);
  },

  methods: {
    setTextContactButton(event: Event): void {
      const target = event.target as HTMLInputElement | null;

      if (!target) {
        return;
      }

      this.modifyQuiz("set", target.value, ["textContactButton"]);
    },

    setHeaderForm(event: Event) {
      const target = event.target as HTMLTextAreaElement;

      if (
        !this.modifyQuiz("get", "", [
          "questions",
          this.selectedQuestion,
          "contacts",
          "headerMobile",
          "placeholder"
        ])
      ) {
        this.modifyQuiz("set", {placeholder: ""}, [
          "questions",
          this.selectedQuestion,
          "contacts",
          "headerMobile"
        ]);
      }

      this.modifyQuiz("set", target.value, [
        "questions",
        this.selectedQuestion,
        "contacts",
        "headerMobile",
        "placeholder"
      ]);
    },

    setParagraphForm(event: Event) {
      const target = event.target as HTMLTextAreaElement;

      if (
        !this.modifyQuiz("get", "", [
          "questions",
          this.selectedQuestion,
          "contacts",
          "paragraphMobile",
          "placeholder"
        ])
      ) {
        this.modifyQuiz("set", {placeholder: ""}, [
          "questions",
          this.selectedQuestion,
          "contacts",
          "paragraphMobile"
        ]);
      }

      this.modifyQuiz("set", target.value, [
        "questions",
        this.selectedQuestion,
        "contacts",
        "paragraphMobile",
        "placeholder"
      ]);
    },

    setContacts(contact: ContactKey) {
      const currentContact =
        this.quiz.questions[this.selectedQuestion]?.contacts?.[contact];

      if (!currentContact) {
        return;
      }

      const path = [
        "questions",
        this.selectedQuestion,
        "contacts",
        contact,
        "bool"
      ];

      this.modifyQuiz("set", !currentContact.bool, path);
    },

    changeMaskVisible() {
      this.currentQuestionData.phoneMask = !this.currentQuestionData.phoneMask;
    },

    getSizeInNextButton() {
      return Math.max(14, this.textContactButton.length + 2 || 0);
    },

    changeConnection(event: Event) {
      const target = event.currentTarget as HTMLLabelElement;
      const inputElement = target.firstChild as HTMLInputElement;

      if (!inputElement) {
        return;
      }

      const idInput = inputElement.id as string;
      const index = this.currentConnectionId.indexOf(idInput);
      const titleConnection = this.getTitleFromConnectionById(idInput);

      if (index === -1) {
        if (!this.currentQuestionData?.connection) {
          this.modifyQuiz(
            "set",
            [
              {
                bool: false,
                text: "Телефон"
              },
              {
                bool: false,
                text: "Whats App"
              },
              {
                bool: false,
                text: "Viber"
              },
              {
                bool: false,
                text: "Telegram"
              }
            ],
            ["questions", this.selectedQuestion, "connection"]
          );
        }

        this.currentQuestionData.connection?.forEach(
          (connectionObj: connection) => {
            if (connectionObj.text === titleConnection) {
              const currentIndex = this.connections.findIndex((item) => {
                return item.title === connectionObj.text;
              });

              this.modifyQuiz("set", true, [
                "questions",
                this.selectedQuestion,
                "connection",
                currentIndex,
                "bool"
              ]);
            }
          }
        );
      } else {
        this.currentQuestionData.connection?.forEach(
          (connectionObj: connection) => {
            if (connectionObj.text === titleConnection) {
              const currentIndex = this.connections.findIndex((item) => {
                return item.title === connectionObj.text;
              });

              this.modifyQuiz("set", false, [
                "questions",
                this.selectedQuestion,
                "connection",
                currentIndex,
                "bool"
              ]);
            }
          }
        );
      }
    },

    getTitleFromConnectionById(id: string): string {
      return this.connections.filter((connection) => {
        return connection.title ? connection.id === id : "";
      })[0].title;
    },

    toggleDropdown() {
      this.isOpenDropdown = !this.isOpenDropdown;
    },

    normalizeCountry(value: unknown): CountryName {
      if (
        value === "Казахстан" ||
        value === "Казахстан (+7)" ||
        value === "kz" ||
        value === "KZ"
      ) {
        return "Казахстан (+7)";
      }

      return "Россия (+7)";
    },

    selectCountry(country: Country) {
      this.selectedCountry = country;
      this.isOpenDropdown = false;
      this.contacts.country = country.name;
    },

    setDefaultRegionalNumber() {
      this.currentQuestionData.contacts.country = this.selectedCountry?.name;
    },

    onClickOutside(event: Event) {
      const root = this.$refs.countrySelectRoot as HTMLElement | undefined;

      if (!root) {
        return;
      }

      const target = event.target as Node;

      if (!root.contains(target)) {
        this.isOpenDropdown = false;
      }
    }
  },

  computed: {
    quiz() {
      return this.$quizStore.getQuiz;
    },

    selectedQuestion() {
      return this.$quizStore.getSelectedQuestion;
    },

    selectedVersion() {
      return this.$quizStore.getSelectedVersion;
    },

    mobileVersion() {
      return this.selectedVersion === "Мобильная";
    },

    currentQuestionData() {
      return this.quiz.questions[this.selectedQuestion];
    },

    contacts(): Contacts {
      return this.currentQuestionData.contacts;
    },

    textContactButton(): string {
      const value = this.modifyQuiz("get", "", ["textContactButton"]);

      if (typeof value === "string") {
        return value;
      }

      return "";
    },

    currentConnectionId() {
      const connFromQuestion = this.modifyQuiz("get", "", [
        "questions",
        this.selectedQuestion,
        "connection"
      ]);
      // const connFromQuestion = this.currentQuestionData.connection;

      if (Array.isArray(connFromQuestion)) {
        return connFromQuestion.reduce((acc: string[], connObj: connection) => {
          if (connObj.bool) {
            const found = (
              this.connections as {id: string; title: string}[]
            ).find((c) => c.title === connObj.text);

            if (found) {
              acc.push(found.id);
            }
          }

          return acc;
        }, []);
      } else {
        return [];
      }
    },

    visibleFormFields(): {key: string; label: string}[] {
      const fields: {key: string; label: string}[] = [];

      if (this.currentQuestionData.contacts?.name?.bool) {
        fields.push({
          key: "name",
          label: "Введите имя"
        });
      }

      if (this.currentQuestionData.contacts?.email?.bool) {
        fields.push({
          key: "email",
          label: "Введите email"
        });
      }

      if (this.currentQuestionData.contacts?.connectionList?.bool) {
        fields.push({
          key: "connection",
          label: "Выберите способ связи"
        });
      }

      if (this.currentQuestionData.contacts?.phone?.bool) {
        fields.push({
          key: "phone",
          label: "Введите телефон"
        });
      }

      return fields;
    },

    fieldIndexMap(): Record<string, number> {
      return this.visibleFormFields.reduce(
        (acc, field, index) => {
          acc[field.key] = index + 1;
          return acc;
        },
        {} as Record<string, number>
      );
    }
  },

  watch: {
    quiz: {
      handler() {
        if (!this.currentQuestionData.contacts.country) {
          this.setDefaultRegionalNumber();
        }
      },
      deep: true
    }
  }
});
</script>
